<template>
  <v-container fluid class="filters-panel ma-0">
    <v-container >
      <v-layout class="filters-panel">
        <v-row align="center" justify="center">
          <v-flex xs12 md6>
            <v-layout column align-left>
            <p id="users_count">
              {{ count }} Usuarios registrados
              <span id="contacted_users_count">
                <span v-if="contactedCount==1">
                  {{ contactedCount }} USUARIO CONTACTADO
                </span>
                <span v-if="contactedCount>1">
                  {{ contactedCount }} USUARIOS CONTACTADOS
                </span>
              </span>
            </p>
          </v-layout>
          </v-flex>

          <v-flex xs12 md6 v-if="!expanded">
            <v-layout column align-end>
              <!--<v-btn class="app-button" id="open-filters-button" color="primary">
              FILTRAR RESULTADOS</v-btn>-->
            </v-layout>
          </v-flex>

          <v-flex xs12 md6 v-else>
            <v-layout row align-end>
              <v-col cols="6">
                <v-btn class="app-button" id="eliminate-filters-button" color="white">
                  <span class="primary--text">ELIMINAR FILTROS</span>
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn class="app-button" id="apply-filters-button" color="primary">
                APLICAR FILTROS</v-btn>
              </v-col>
            </v-layout>
          </v-flex>

          <v-flex xs12 v-if="expanded">
            <v-layout row align-end>
              <v-col cols="4">
                SYmptoms filter
              </v-col>
              <v-col cols="4">
                <multi-switch :options="contactedOptions" />
              </v-col>
              <v-col cols="4">
                <multi-switch :options="disabilityOptions" />
              </v-col>
            </v-layout>
          </v-flex>
            
        </v-row>

      </v-layout>
    </v-container>
  </v-container>
</template>

<script>

  import MultiSwitch from './MultiSwitch'

  export default {
    name: 'Filters',

    components: {
      MultiSwitch
    },

    data: () => ({
      expanded: false,
      contactedOptions: [
        { text: 'Todos', value: 'all' },
        { text: 'No Contactado', value: 'notContacted' },
        { text: 'Contactado', value: 'contacted' },
      ],
      disabilityOptions: [
        { text: 'Todos', value: 'all' },
        { text: 'Si', value: 'disability' },
        { text: 'No', value: 'noDisability' },
      ],
    }),

    computed: {
      count() {
        return this.$store.getters['users/count']
      },
      contactedCount() {
        return this.$store.getters['users/contactedCount']
      },
    }
  }
</script>

<style lang="scss" scoped>
  .filters-panel {
    min-height: 142px;
    background-color: #e2f3fb;
    width: 100%;
  }

  #open-filters-button {
    width: fit-content;
  }

  #users_count {
    font-size: 28px;
    color: 1.75rem;
  }

  #contacted_users_count {
    font-size: 1.125rem;
    color: #404a57;
    margin-left: 0.5rem;
  }
</style>